import React from "react";
import { Box, Typography } from "@mui/material";

// ✅ UPDATED TYPES
interface LuxuryInputProps {
  label?: string;
  placeholder: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: boolean;
  helperText?: string;
  multiline?: boolean;
  rows?: number;
  name?: string;
  fullWidth?: boolean; // ✅ NEW
}

const LuxuryInput: React.FC<LuxuryInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  error = false,
  helperText,
  multiline = false,
  rows = 3,
  name,
  fullWidth = true, // default full width
}) => {
  return (
    <Box sx={{ mb: 3, width: fullWidth ? "100%" : "auto" }}>
      
      {/* LABEL */}
      {label && (
        <Typography
          sx={{
            color: "rgba(255,255,255,0.9)",
            fontSize: 13,
            mb: 1,
          }}
        >
          {label}
        </Typography>
      )}

      {/* INPUT BOX */}
      <Box
        sx={{
          position: "relative",
          borderRadius: "16px",
          overflow: "hidden",

          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(10px)",

          border: error
            ? "1px solid #ff4d4f" // 🔥 error border
            : "1px solid rgba(255,255,255,0.25)",

          transition: "0.3s",

          "&:focus-within": {
            border: error
              ? "1px solid #ff4d4f"
              : "1px solid #0f63a5",
            boxShadow: error
              ? "0 0 6px rgba(255,77,79,0.5)"
              : "0 0 8px rgba(15,99,165,0.5)",
          },

          /* ✅ PLACEHOLDER */
          "& input::placeholder, & textarea::placeholder": {
            color: "rgba(255,255,255,0.7)",
            opacity: 1,
          },
        }}
      >
        {/* INPUT / TEXTAREA */}
        {multiline ? (
          <textarea
            name={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            rows={rows}
            style={{
              width: "100%",
              padding: "14px 16px",
              border: "none",
              outline: "none",
              background: "transparent",
              color: "#fff",
              fontSize: "14px",
              resize: "none",
            }}
          />
        ) : (
          <input
            name={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            style={{
              width: "100%",
              padding: "14px 16px",
              border: "none",
              outline: "none",
              background: "transparent",
              color: "#fff",
              fontSize: "14px",
            }}
          />
        )}
      </Box>

      {/* HELPER TEXT */}
      {helperText && (
        <Typography
          sx={{
            color: error ? "#ff4d4f" : "rgba(255,255,255,0.6)",
            fontSize: 12,
            mt: 0.5,
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default LuxuryInput;